module.exports = __webpack_public_path__ + "assets/68e2594efde133e169fbcc9b61f68d6c.svg";